import React from "react";
import { Container, CssBaseline } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from './theme/theme'; // import your theme

import Topbar from "./components/Topbar";
import HeroSlider from "./components/HeroSlider";
import About from "./pages/About";
import ServicesPage from "./pages/ServicesPage";
import TeamPage from "./pages/TeamPage";
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import WhatsAppButton from "./components/WhatsAppButton";
import Footer from "./components/Footer";
import { ContentProvider } from "./context/ContentContext";

function MainSite() {
  return (
    <>
      <Topbar />

      {/* Hero section full width */}
      <section id="home">
        <HeroSlider />
      </section>

      {/* Other sections inside container */}
      <Container maxWidth="lg" sx={{ mt: 0, mb: 0 }}>
        <section id="about" style={{ marginTop: "80px" }}>
          <About />
        </section>

        <section id="services" style={{ marginTop: "80px" }}>
          <ServicesPage />
        </section>

        <section id="contact" style={{ marginTop: "80px" }}>
          <ContactPage />
        </section>

        <section id="portfolio" style={{ marginTop: "80px" }}>
          <PortfolioPage />
        </section>
      </Container>

      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Applies global background & resets */}
      <Router>
        <ContentProvider>
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/*" element={<MainSite />} />
          </Routes>
        </ContentProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
